module.exports = __webpack_public_path__ + "static/jennifer_zamora-fd7af5208eea59d471a5961719035750.jpg";